export const FILTER_DEBOUNCE_TIME_MS = 500;
export const SEARCH_DEBOUNCE_TIME_MS = 400;
export const THROTTLE_INTERVAL_MS = 16; // approx 60 FPS
